import { Steps } from "./types";

export const landingPageSteps: Steps = {
  l1: {
    id: "l1",
    slug: "soft-landing-hypertension-todo",
    text: "Soft Landing Hypertension",
    clarification: "Landningsida för annonser",
    type: "information",
    allowDirectAccess: true,
    nextStep: () => "q1",
  },
  l2: {
    id: "l2",
    slug: "soft-landing-obesity-todo",
    text: "Soft Landing Obesity",
    clarification: "Landningsida för annonser",
    type: "information",
    allowDirectAccess: true,
    nextStep: () => "q5",
  },
};
